<template>
  <div
    id="modal-popup"
    class="p-4 max-h-screen-90 overflow-y-auto bg-white rounded-lg shadow"
    v-click-outside="handleClose"
  >
    <div class="flex justify-end">
      <i @click="close" class="fas fa-times-circle cursor-pointer"></i>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ModalContent",
  props: {
    close: {
      type: Function,
      require: true
    }
  },
  components: {},
  data() {
    return {
      opened: false
    };
  },
  methods: {
    handleClose() {
      if (this.opened) {
        if (
          !document.getElementById("modal-popup").contains(window.event.target)
        ) {
          this.close();
        }
      } else {
        this.opened = true;
      }
    }
  },
  directives: {
    "click-outside": {
      mounted(el, { value: closeFunction }) {
        window.addEventListener("click", closeFunction);
      },
      unmounted(el, { value: closeFunction }) {
        window.removeEventListener("click", closeFunction);
      }
    }
  }
};
</script>
